import { useMutation, useQueryClient } from 'react-query';
import { Axios } from '@utils/api/axios-instance.ts';
import { POST_URL } from '@utils/api/endpoints.ts';
import { AxiosError } from 'axios';
import { BaseError } from '@utils/types/shared/base.ts';
import { CUSTOM_MODEL_QUERY_KEYS } from './query-keys';
import { ContributeReadiness } from './use-contribute-segment.tsx';

export interface ContributeWholeFilePayload {
  model_id: number;
}

/**
 * Add the whole recording, with the document's current text as its
 * transcript, to a custom model. Adding it again rewrites the transcript
 * rather than adding a second copy.
 */
export const useContributeWholeFile = (
  sessionId: string,
  documentId: string
) => {
  const queryClient = useQueryClient();
  return useMutation<
    ContributeReadiness,
    AxiosError<BaseError>,
    ContributeWholeFilePayload
  >(
    async payload => {
      const { data } = await Axios.post<ContributeReadiness>(
        POST_URL(sessionId, documentId).contributeTrainingFile,
        payload
      );
      return data;
    },
    {
      onSuccess: (_data, variables) => {
        queryClient.invalidateQueries(
          CUSTOM_MODEL_QUERY_KEYS.data(variables.model_id)
        );
        queryClient.invalidateQueries(
          CUSTOM_MODEL_QUERY_KEYS.detail(variables.model_id)
        );
      }
    }
  );
};
